<template>
  <form class="form-inline row" v-on:submit="send">
    <div class="form-group mb-2 col-12 col-xl-9">
      <input type="text" class="form-control"
      v-model="message" maxlength="220"
      ondrop="return false;">
    </div>
    <div class="col">
    <button type="submit" class="btn btn-outline-secondary mb-2">Envoyer</button>
    </div>
  </form>
</template>

<script>

export default {
  name: 'GameChatInput',
  props: {
    gameId: String,
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    send(event) {
      event.preventDefault();
      if (this.message !== '') {
        this.$emit('send', this.message);
        this.message = '';
      }
    },
  },
};
</script>

<style scoped>
input.form-control{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/games/GameChatInput.vue